export const typeButtonsData = [
  {
    image: {
      height: 524,
      url: 'https://platform-resources-staging.s3.ap-southeast-1.amazonaws.com/media/d53f769f-a51c-4491-865c-2f88885020c8.png',
      width: 524,
      name: 'CĂN HỘ LOẠI D',
    },
    objects: [
      {
        id: '67595ef15444e18f4b62d323',
        coordinates: [0.49275, 0.342],
      },
      {
        id: '67595ef55444e18f4b62d32e',
        coordinates: [0.55075, 0.748],
      },
      {
        id: '67595efb5444e18f4b62d340',
        coordinates: [0.56675, 0.586],
      },
      {
        id: '67595f055444e18f4b62d356',
        coordinates: [0.63275, 0.376],
      },
      {
        id: '67595f155444e18f4b62d377',
        coordinates: [0.63675, 0.194],
      },
      {
        id: '67595f105444e18f4b62d36c',
        coordinates: [0.46675, 0.486],
      },
      {
        id: '67595f0a5444e18f4b62d361',
        coordinates: [0.38475, 0.796],
      },
      {
        id: '67595f005444e18f4b62d34b',
        coordinates: [0.630150915662408, 0.49106486655189424],
      },
    ],
  },
  {
    image: {
      height: 524,
      url: 'https://platform-resources-staging.s3.ap-southeast-1.amazonaws.com/media/43c621e3-d1a1-456a-85fd-2761da08c668.png',
      width: 524,
      name: 'CĂN HỘ LOẠI E',
    },
    objects: [
      {
        id: '675952915444e18f4b62c003',
        coordinates: [0.78275, 0.502],
      },
      {
        id: '675952875444e18f4b62bff8',
        coordinates: [0.65675, 0.31],
      },
      {
        id: '6759527f5444e18f4b62bfed',
        coordinates: [0.48875, 0.192],
      },
      {
        id: '6759529b5444e18f4b62c00e',
        coordinates: [0.65475, 0.686],
      },
      {
        id: '675952b05444e18f4b62c026',
        coordinates: [0.16275, 0.772],
      },
      {
        id: '675952bb5444e18f4b62c031',
        coordinates: [0.50475, 0.546],
      },
      {
        id: '675952cf5444e18f4b62c047',
        coordinates: [0.52075, 0.348],
      },
      {
        id: '67595b8b5444e18f4b62cbc1',
        coordinates: [0.41875, 0.776],
      },
    ],
  },
  {
    image: {
      height: 524,
      url: 'https://platform-resources-staging.s3.ap-southeast-1.amazonaws.com/media/e848053d-ba09-4c82-8f89-bfa5da03ec3d.png',
      width: 524,
      name: 'CĂN HỘ LOẠI B',
    },
    objects: [
      {
        id: '675962385444e18f4b62d68e',
        coordinates: [0.44675, 0.364],
      },
      {
        id: '6759623c5444e18f4b62d69c',
        coordinates: [0.40875, 0.764],
      },
      {
        id: '675962415444e18f4b62d6a8',
        coordinates: [0.43875, 0.546],
      },
      {
        id: '6759624f5444e18f4b62d6c9',
        coordinates: [0.39275, 0.194],
      },
      {
        id: '675962585444e18f4b62d6e6',
        coordinates: [0.56475, 0.324],
      },
      {
        id: '675962455444e18f4b62d6b3',
        coordinates: [0.67875, 0.608],
      },
      {
        id: '6759624a5444e18f4b62d6be',
        coordinates: [0.56875, 0.74],
      },
      {
        id: '675a6490fef38c25a3605f6c',
        coordinates: [0.67675, 0.45],
      },
    ],
  },

  {
    image: {
      height: 1159,
      url: 'https://platform-resources-staging.s3.ap-southeast-1.amazonaws.com/media/f7a55124-7836-462b-9721-aad3ee992b8d.jpg',
      width: 2048,
      name: 'HỆ TIỆN ÍCH',
    },
    objects: [
      {
        id: '67e26c01d10d75c7dcedf2f1',
        coordinates: [0.047944423891239686, 0.07798891641699479],
      },
      {
        id: '67e26c0dd10d75c7dcedf2fa',
        coordinates: [0.5307493909645954, 0.07007126023459391],
      },
      {
        id: '67e26a65d10d75c7dcedf242',
        coordinates: [0.7154982938968081, 0.36869606029531005],
      },
      {
        id: '67e26a6fd10d75c7dcedf24b',
        coordinates: [0.9077368866311433, 0.2996065714010813],
      },
      {
        id: '67e26a76d10d75c7dcedf256',
        coordinates: [0.6034134194889924, 0.48614819141549886],
      },
      {
        id: '67e26a81d10d75c7dcedf25f',
        coordinates: [0.6008067945027641, 0.30421253732736325],
      },
      {
        id: '67e26a8ad10d75c7dcedf268',
        coordinates: [0.6261096605744125, 0.5907859078590786],
      },
      {
        id: '67e26a94d10d75c7dcedf271',
        coordinates: [0.4618802076517903, 0.7212713412326428],
      },
      {
        id: '67e26aa2d10d75c7dcedf27a',
        coordinates: [0.9266349177812983, 0.47139765460887273],
      },
      {
        id: '67e26aadd10d75c7dcedf284',
        coordinates: [0.7493844187177756, 0.4241864972283447],
      },
      {
        id: '67e26abdd10d75c7dcedf28d',
        coordinates: [0.7154982938968081, 0.44606483845346745],
      },
      {
        id: '67e26ac6d10d75c7dcedf296',
        coordinates: [0.6561975754601149, 0.4610342298180251],
      },
      {
        id: '67e26ad2d10d75c7dcedf29f',
        coordinates: [0.6262213881184897, 0.4414588718797574],
      },
      {
        id: '67e26adbd10d75c7dcedf2a8',
        coordinates: [0.6210081381460332, 0.3769753398478167],
      },
      {
        id: '67e26ae4d10d75c7dcedf2b1',
        coordinates: [0.6724889816240416, 0.3723693732741067],
      },
      {
        id: '67e26bded10d75c7dcedf2d6',
        coordinates: [0.5184272224314007, 0.5174188345402435],
      },
      {
        id: '67e26be9d10d75c7dcedf2df',
        coordinates: [0.6898173847567451, 0.41053047607783166],
      },
      {
        id: '67e26bf6d10d75c7dcedf2e8',
        coordinates: [0.8018370986948787, 0.35708629684662574],
      },
    ],
  },
];
